import { LanguageEnum } from "@perxis-auto/shared/lib";
const formatShortTime = () => {
  return [
    "shortTime",
    // @ts-ignore
    (value, lng = LanguageEnum.Ru) => {
      return new Intl.DateTimeFormat(lng, {
        hour: "2-digit",
        minute: "2-digit",
        timeZone: "UTC"
      }).format(new Date(value));
    }
  ];
};
export {
  formatShortTime
};
